<template>
    <div class="gallery-container">
        <pulse-loader :loading="loading"></pulse-loader>
        <div v-if="gallery.length == 0 && !loading" class="no-results text-center">
        </div>
        <div v-else :id="elementId" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner">
                <div v-for="(group, index) in chunk(gallery, numCols)" v-bind:key="index" :class="{'carousel-item': true, 'active': index == 0}">
                  <div class="row">
                    <div class="picture" :class="'col-' + (12 / numCols)" v-for="picture in group">
                      <img :src="picture.image ? picture.image.big : ''" alt="boat">
                    </div>
                  </div>
                </div>
            </div>
            <a class="carousel-control-prev" :href="'#' + elementId" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
            </a>
            <a class="carousel-control-next" :href="'#' + elementId" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
            </a>
        </div>
    </div>
</template>

<style lang="scss" scoped>
  .gallery-container {
    background: #f0f0f0;
    height: 300px;
    overflow: hidden;
    .picture {
      position: relative;
      height: 300px;
      padding-left: 0;
      padding-right: 0;
      overflow: hidden;
      img {
        height: 100%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }

    }
  }
</style>

<script>
import CatalogModelMixin from "../mixins/CatalogModel";

export default {
  mixins: [CatalogModelMixin],

  props: {
    model: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      gallery: [],
      loading: false,
      numCols: 3
    };
  },

  computed: {
    elementId() {
      return "gallery-" + this.model;
    }
  },

  created() {
    this.getGallery();

    this.onResize();

    this.onResizeBinding = this.onResize.bind(this);
    window.addEventListener('resize', this.onResizeBinding);
  },

  destroyed() {
    window.removeEventListener('resize', this.onResizeBinding);
  },

  methods: {

    onResize() {
      // // Small devices (landscape phones, 576px and up)
      // @media (min-width: 576px) { ... }

      // // Medium devices (tablets, 768px and up)
      // @media (min-width: 768px) { ... }

      // // Large devices (desktops, 992px and up)
      // @media (min-width: 992px) { ... }

      // // Extra large devices (large desktops, 1200px and up)
      // @media (min-width: 1200px) { ... }
      if (window.innerWidth > 992) {
        this.numCols = 3;
      } else if (window.innerWidth > 768) {
        this.numCols = 2;
      } else {
        this.numCols = 1;
      }
    },
    chunk(array, length) {

      let totalChunks = [];
      let chunkLength = parseInt(length, 10);

      if (chunkLength <= 0) {

          ("development") !== 'production' && _.warn(
              'The chunk filter requires an argument defining the chunk size.'
          );

          return array;
      }

      // Loop through the data and divide it into chunks
      for (let i = 0; i < array.length; i += chunkLength) {
          totalChunks.push(array.slice(i, i + chunkLength));
      }

      // Return the chunks of data
      return totalChunks;
    },

    getGallery() {
      this.loading = true;

      this.getCatalogModelGallery(this.model).then(response => {
        this.gallery = response.data;
        this.loading = false;
      });
    }
  }
};
</script>
